import { useState, useEffect } from 'react'
import { Row, Col, Image } from 'react-bootstrap'
import { toast } from 'react-toastify'
import api from '../../../services/api'
import { Warning, HandPalm } from 'phosphor-react'
//import Gauge from "../../../assets/VehicleInfo/alert-icons/Gauge.svg";
import SpeedingGauge from '../../../assets/VehicleInfo/alert-icons/SpeedingGauge.svg'
import { errorApi } from '../../../utils/errorApi'

import styles from './styles.module.css'
import { useLoading } from '../../../hooks/LoadingContext'

function VehicleAlerts({ vehicleId, date = '' }) {
  const [alertsInfo, setAlertsInfo] = useState({})

  const { setIsLoading } = useLoading()

  useEffect(() => {
    async function loadData() {
      setIsLoading(true)
      try {
        const alertsData = await api.get(`/company/vehicles/${vehicleId}/alerts?date=${date}`)
        setAlertsInfo(alertsData.data)
      } catch (err) {
        toast.error(
          errorApi(err, 'Falha ao buscar as estatísticas do veículo. Tente novamente mais tarde.'),
        )
      }
      setIsLoading(false)
    }
    loadData()
  }, [vehicleId, date, setIsLoading])

  return (
    <div>
      <Row>
        <Col className={`${styles.alertContainer} col-12 col-md-5 border`}>
          <Row>
            <Col className="col-4 text-center">
              <Warning className={styles.alertIcon} color="#FFC700" size={50} weight="light" />{' '}
            </Col>
            <Col className="col-8 text-center d-flex flex-column align-items-center justify-content-center">
              <span style={{ fontSize: 12 }}>Atividades suspeitas</span>
              <span style={{ fontSize: 18, fontWeight: 'bold' }}>
                {alertsInfo.suspicious_activities + ' registros'}
              </span>
            </Col>
          </Row>
        </Col>
        <Col className={`${styles.alertContainer} col-12 col-md-5 offset-md-1 border`}>
          <Row>
            <Col className="col-4 text-center">
              <HandPalm className={styles.alertIcon} color="#DB222A" size={50} weight="light" />{' '}
            </Col>
            <Col className="col-8 text-center d-flex flex-column align-items-center justify-content-center">
              <span style={{ fontSize: 12 }}>Infrações de trânsito</span>
              <span style={{ fontSize: 18, fontWeight: 'bold' }}>
                {alertsInfo.traffic_violations + ' registros'}
              </span>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col className={`${styles.alertContainer} col-12 col-md-5 border`}>
          <Row>
            <Col className="col-4 text-center">
              <Image className={styles.alertIcon} width={50} src={SpeedingGauge} />
            </Col>
            <Col className="col-8 text-center d-flex flex-column align-items-center justify-content-center">
              <span style={{ fontSize: 12 }}>Excesso de velocidade</span>
              <span style={{ fontSize: 18, fontWeight: 'bold' }}>
                {alertsInfo.speeding + ' registros'}
              </span>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default VehicleAlerts
